import { useCurrentPractitionerPerms } from '#src/hooks/useCurrentPractitionerPerms.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export function useShowMedplumLink(): boolean {
  const showLinkOverlay = usePortalStore((state) => state.showLinkOverlay)
  const { isTech } = useCurrentPractitionerPerms()
  return showLinkOverlay || isTech
}
